import Config from '@config';
import { CACHE_EXPIRATION_TIME } from '@gasbi/shared/common/features/constants';
import {
  FiltersGrid,
  Pagination,
  infiniteQueryOptions,
  normalizeInfiniteQueryData,
} from '@gasbi/shared/index';
import { createApi } from '@reduxjs/toolkit/query/react';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

import { SupplyTariff, SupplyTariffRequestBody } from './types';

export const supplyTariffsApi = createApi({
  reducerPath: 'supplyTariffsApi',
  baseQuery: axiosBaseQuery({
    baseUrl: `${Config.VITE_API_URL}/supply-tariffs`,
  }),
  keepUnusedDataFor: CACHE_EXPIRATION_TIME,
  tagTypes: ['SupplyTariff', 'SupplyTariffs'],
  endpoints: builder => ({
    getSupplyTariffI: builder.infiniteQuery<
      SupplyTariff[],
      FiltersGrid,
      Pagination
    >({
      infiniteQueryOptions,
      query: ({ queryArg, pageParam }) => ({
        url: `/`,
        params: { ...queryArg, ...pageParam },
      }),
      providesTags: () => ['SupplyTariff', 'SupplyTariffs'],
    }),
    getSupplyTariffById: builder.query<SupplyTariff, string>({
      query: id => ({
        url: `/${id}`,
      }),
      providesTags: () => ['SupplyTariff'],
    }),
    createSupplyTariff: builder.mutation<string, SupplyTariffRequestBody>({
      query: data => ({
        url: '/',
        method: 'POST',
        data,
      }),
      invalidatesTags: () => ['SupplyTariffs'],
    }),
    updateSupplyTariff: builder.mutation<void, SupplyTariffRequestBody>({
      query: data => ({
        url: `/${data.id}`,
        method: 'PUT',
        data,
      }),
      invalidatesTags: (_, __, data) => [
        'SupplyTariffs',
        { type: 'SupplyTariff', id: data.id },
      ],
    }),
  }),
});

export const {
  useGetSupplyTariffByIdQuery,
  useCreateSupplyTariffMutation,
  useUpdateSupplyTariffMutation,
} = supplyTariffsApi;

export const useGetSupplyTariffIInfiniteQuery =
  normalizeInfiniteQueryData<SupplyTariff>(
    supplyTariffsApi.useGetSupplyTariffIInfiniteQuery,
  );
